import { o_util } from "@gr-common/head/namespaces";
import { assignNamespace } from "@gr-common/head/namespace-utils";
import { get } from "./toggle.js";

/*                    */
assignNamespace(o_util, "toggle", { get });
